import React from 'react';
import { useTranslation } from 'react-i18next';

import { Container, Grid } from '@mui/material';

export enum DELETED_TYPE {
  SOFT = 'Soft',
  HARD = 'Hard',
}

export interface DeletedCandidateViewProps {
  deletedType?: DELETED_TYPE;
}

export const DeletedCandidateView: React.FC<DeletedCandidateViewProps> = ({ deletedType }) => {
  const { t } = useTranslation('candidate');

  const renderMessage = () => {
    if (deletedType === DELETED_TYPE.SOFT) {
      return t('candidate:GENERAL.PAGES.softDeleteMessage');
    }
    if (deletedType === DELETED_TYPE.HARD) {
      return t('candidate:GENERAL.PAGES.hardDeleteMessage');
    }
  };

  return (
    <Container maxWidth="md">
      <div className="tag-ds ">
        <div className="separator" />
      </div>
      <Grid container spacing={3} direction="column">
        <Grid item>
          <p>{renderMessage()}</p>
        </Grid>
      </Grid>
    </Container>
  );
};
